import BackButton from '@portal/features/navigation/BackButton'
import { Header } from '@portal/features/navigation/Header'
import EditProfilePage from '@portal/features/profile/EditProfilePage'
import { TextTitle } from '@portal/features/titles'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => (
  <>
    <Header.Left>
      <BackButton to="/dashboard" />
    </Header.Left>
    <Header.Center>
      <TextTitle title="Edit profile" />
    </Header.Center>
    <EditProfilePage />
  </>
)

export const Route = createFileRoute('/_app/profile')({
  component: RouteComponent,
})
